'use strict';

var $ = require('../../jquery-extend'),
    swig = require('swig'),
    idCounter = 0;

function ModalTpl(options) {
    var opt = options || {},
        root,
        modalData = null,
        preRender = null,
        preHide = null,
        $boxModal = null,
        cacheTpl = {},
        customId = false,
        modalDataDefault = {
            id: '',
            title: '',
            subtitle: '',
            body: '',
            footer: '',
            cssClass: ''
        };

    /**
     * Inizializza tutte le options per utilizzare il modal
     * @returns {*}
     */
    function initialize() {

        opt.template = !$.isEmpty(opt.template) ? opt.template : require('../view/modal.html.twig');
        opt.cache = $.isDefined(opt.cache) ? opt.cache : true;
        opt.resetModalVarOnClose = $.isDefined(opt.resetModalVarOnClose) ? opt.resetModalVarOnClose : true;
        opt.el = $.isDefined(opt.el) ? opt.el : 'body';
        opt.$el = $(opt.el);
        resetModalVar();

        if ($.isEmpty(opt.$el)) {
            throw new Error('You need to specify an element selector (\'el\')');
        }

        if ($.isDefinedAndNotNull(opt.preRender)) {
            setPreRender(opt.preRender);
        }

        if (!$.isEmpty(opt.modalData)) {
            setModalVar(opt.modalData);
        }

        return root;
    }

    /**
     * Setta il selettore del modale
     * @returns {*}
     */
    function setSelectorModal() {
        root.selectorModal = '#' + modalData.id;

        return root;
    }

    /**
     * Set di una funzione di pre-render del modal
     */
    function setPreRender(handler) {
        if ($.isFunction(handler)) {
            preRender = handler;
        }

        return root;
    }

    /**
     * Esegue la funzione di pre-render del modal
     */
    function executePreRender() {
        if ($.isFunction(preRender)) {
            preRender();
        }

        return root;
    }


    /**
     * Set di una funzione di pre-hide del modal
     */
    function setPreHide(handler) {
        if ($.isFunction(handler)) {
            preHide = handler;
        }

        return root;
    }

    /**
     * Esegue la funzione di pre-hide del modal
     */
    function executePreHide(e) {
        if ($.isFunction(preHide)) {
            preHide(e);
        }

        return root;
    }

    /**
     * Recupera il template richiesto e se abilitato lo salva in cache
     * @param data
     * @returns {*}
     */
    function getTpl(data) {
        if ($.isEmpty(data.url)) {
            throw new Error('You need to specify the template url.');
        }

        if (opt.cache) {
            var key = JSON.stringify(data);

            if (!$.isEmpty(cacheTpl[key])) {
                return cacheTpl[key];
            }
        }

        return $.ajax(data).success(function (html) {
            cacheTpl[key] = html;
        });
    }

    /**
     * Dato un oggetto di configurazioni carica il template e lo renderizza
     * @param data
     * @returns {*}
     */
    function load(data) {
        return $.when(getTpl(data))
            .then(function (html) {
                setModalVar('body', html);
                render();
            });
    }

    /**
     * A partire dalle variabili di modalData lo renderizza, lo mostra e torna l'obj jquery.
     * @returns {jQuery}
     */
    function render() {

        if (!customId) {
            modalData.id = uniqueId('boxModal_');
        }

        setSelectorModal();

        if ($(root.selectorModal).exist()) {
            destroyModal($(root.selectorModal));
        }

        opt.$el.append(swig.render(opt.template, {locals: {modal: modalData}}));

        $boxModal = $(root.selectorModal);

        $boxModal.on('shown.bs.modal', function () {
            executePreRender();
        });

        $boxModal.on('hide.bs.modal', function (e) {
            executePreHide(e);
        });

        $boxModal.on('hidden.bs.modal', function () {
            destroyModal($(this));
        });

        show();

        return $boxModal;
    }

    /**
     * Rimuove il modal dal dom e gli eventi ad esso associati
     * @param $element
     * @returns {*}
     */
    function destroyModal($element) {
        hide();
        $element.unbind();
        $element.remove();

        if (opt.resetModalVarOnClose) {
            resetModalVar();
        }

        return root;
    }

    /**
     * Resetta le variabili del modal
     * @returns {root}
     */
    function resetModalVar() {
        modalData = modalDataDefault;
        customId = false;
        preRender = null;
        preHide = null;

        return root;
    }

    /**
     * Setta una variabile (o piu) del modal
     * @param mixed
     * @param value
     * @returns {root}
     */
    function setModalVar(mixed, value) {

        if ($.isDefinedAndNotNull(mixed)) {

            if (typeof mixed === 'object') {

                if (mixed.id) {
                    customId = true;
                }

                for (var i in mixed) {
                    modalData[i] = mixed[i];
                }
            } else if ($.isDefinedAndNotNull(value)) {
                modalData[mixed] = value;

                if (mixed === 'id') {
                    customId = true;
                }
            }
        }

        return root;
    }

    /**
     * Mostra il modal
     * @returns {*}
     */
    function show() {
        $boxModal.modal('show');

        return root;
    }

    /**
     * Nasconde il modal
     * @returns {*}
     */
    function hide() {
        $boxModal.modal('hide');

        return root;
    }

    /**
     * Nasconde solo il contenuto del modal
     * @returns {*}
     */
    function hideOnlyBox() {
        $(root.selectorModal + ' .modal-content').hide();

        return root;
    }

    /**
     * Genera lo uniqueId per il modale
     * @param {string} prefix
     * @returns {*}
     */
    function uniqueId(prefix) {
        var id = ++idCounter;

        return prefix + id;
    }

    root = {
        'load': load,
        'render': render,
        'setModalVar': setModalVar,
        'resetModalVar': resetModalVar,
        'selectorModal': null,
        'show': show,
        'hide': hide,
        'hideOnlyBox': hideOnlyBox,
        'setPreRender': setPreRender,
        'setPreHide': setPreHide
    };

    initialize();

    return root;
}

module.exports = ModalTpl;
